import { render, staticRenderFns } from "./ProfilePersonal.vue?vue&type=template&id=1ea6c04c&"
import script from "./ProfilePersonal.vue?vue&type=script&lang=js&"
export * from "./ProfilePersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports